import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { deleteBillingTypeAsync, getBillingTypeByIdAsync,checkedState, unCheckedState,checkedAllState,unCheckedAllState,updateBillingTypeAsync,updateSorting } from './billingTypeSlics';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const BillingTypeItem = (props: any) => {
    const {billingTypeList, t, onopenModal, IsEdit, IsDelete  } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.billingType);

    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountBillingTypeId: number) => {
        dispatch(getBillingTypeByIdAsync(AccountBillingTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountBillingTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteBillingTypeAsync(AccountBillingTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Billing Type Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, billingType: any) => {
        const { checked } = e.target;
        const foundIndex = billingTypeList.findIndex((item: any) => item.AccountBillingTypeId === billingType.AccountBillingTypeId);
        if (foundIndex !== -1) {
            const foundItem = billingTypeList[foundIndex];
            const { isSelected,Systembillingcategoryid, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...billingTypeList.slice(0, foundIndex), updatedItem, ...billingTypeList.slice(foundIndex + 1)];
            dispatch(updateBillingTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                    ShowToast("Billing Type Updated Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', "Billing Type Updated Failed", "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
         <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    <th style={{ width: '15%' }}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-50'>
                            {/* {t('Billing Type')} */}
                            {getValueFromResource('Billing Type',dispatch, t)}
                        {sortColumn === 'BillingType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-25'>
                            {/* {t('Billing Category')} */}
                            {getValueFromResource('Billing Category',dispatch, t)}
                        {sortColumn === 'BillingCategory' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingCategory") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingCategory") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingCategory") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingCategory") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {billingTypeList.length === 0 && <tr><td colSpan={4}><p className='noDataFound mt-3'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p></td></tr>}
                    {billingTypeList.length > 0 && billingTypeList.map((billingTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(billingTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {billingTypeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(billingTypeDetail.AccountBillingTypeId) : undefined}
                            >
                                <span className="d-block">{billingTypeDetail.BillingType}</span>
                            </td>
                            <td>
                            <span className="d-block">{billingTypeDetail.BillingCategory}</span>
                            </td>
                            
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={billingTypeDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, billingTypeDetail) }}
                                        />
                                         
                                    </div>
                                </td>
                            } */}
                             <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onEditClick(billingTypeDetail.AccountBillingTypeId) }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit && (billingTypeDetail.MasterAccountBillingTypeId === null || billingTypeDetail.MasterAccountBillingTypeId === 0) &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete && (billingTypeDetail.MasterAccountBillingTypeId === null || billingTypeDetail.MasterAccountBillingTypeId === 0) &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(billingTypeDetail.AccountBillingTypeId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                <thead>
                    <tr className="fw-bold text-muted">
                        <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={billingTypeList.every((item: any) => item.isSelected === 0) ? false :
                                        (billingTypeList.every((item: any) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
                        <th className='min-w-100%'>BILLING TYPE</th>
                        <th className='min-w-100%'>BILLING CATEGORY</th>
                        <th className='min-w-100% text-end '>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {billingTypeList.length === 0 && <tr><td>No Record Found.</td></tr>}
                    {billingTypeList.length > 0 && billingTypeList.map((billingTypeDetail: any, i: any) => (
                        <tr key={i}>
                             <td>
                                 <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  
                                    <input
                                        type="checkbox"
                                        className="form-check-input widget-9-check"
                                        checked={billingTypeDetail.isSelected == 0 ? false : true}
                                        onChange={(e) => { handleCheckboxChange(e, billingTypeDetail.AccountBillingTypeId) }}
                                    />
                                </div>
                            </td>
                              <td> <a id="kt_OffCanvas"
                                    className='text-gray-800 fw-normal text-hover-primary d-block  fw-bold'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => { onEditClick(billingTypeDetail.AccountBillingTypeId) }}>
                                    {billingTypeDetail.BillingType}
                                </a>
                                <span className={billingTypeDetail.IsDisabled === 'Yes' ? "badge badge-light-dark text-gray-700 fs-7" : "badge badge-light-success fs-7"}>{billingTypeDetail.IsDisabled === 'Yes' ? 'InActive' : 'Active'}</span>

                            </td>
                            <td>
                            {billingTypeDetail.BillingCategory}
                            </td>
                            <td className='text-end'>
                                <div className='d-flex justify-content-end flex-shrink-0'>
                                    <a id="kt_OffCanvas" className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() => { onEditClick(billingTypeDetail.AccountBillingTypeId) }}>
                                        <KTIcon iconName='pencil' className='fs-3' />
                                    </a>
                                    <a className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                        onClick={() => { onDeleteClick(billingTypeDetail.AccountBillingTypeId) }}>
                                        <KTIcon iconName='trash' className='fs-3' />
                                    </a>
                                </div>
                              
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table> */}
           
        </>
    )
    
}

export default BillingTypeItem